module.exports = __webpack_public_path__ + "df6ceb714f15aaf9fea80d684730381a.pdf";